<template>
  <!-- <div
    class="c-header -flex u-bg-green"
    :style="{
      'background-image':
        'url(' + require('@arag/assets/img/slider/slider_medgate.svg') + ')',
    }"
  >
    <div class="c-header__content">
      <img src="@arag/assets/img/medgate_logo.svg" />
      <div class="c-header__text">
        Der kompetente ARAG-Partner für den digitalen Artzbesuch
      </div>
    </div>
    <div class="c-header__image">
      <img src="@/assets/img/slider/medgate.svg" />
    </div>
  </div> -->
  <!-- <div
    class="c-header u-bg-green -contain-bottom"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/header/icon_medgate.svg') + ')',
    }"
  >
    <img
      class="c-header__logo"
      src="@arag/assets/img/medgate_logo.svg"
      width="80"
    />
  </div> -->
  <Header
    class="u-bg-grey -contain-bottom"
    headline="Der kompetente ARAG-Partner für den digitalen Artzbesuch."
    :image="require('@/assets/img/header/icon_medgate.svg')"
    :logo="require('@/assets/img/medgate_logo.svg')"
    logoWidth="80"
    @openChat="$emit('open-chat')"
    :hideButton="from === 'chat'"
  />
  <p class="ion-padding-top ion-hide-lg-up">
    <b>Der kompetente ARAG-Partner für den digitalen Artzbesuch.</b>
  </p>
  <p>
    In bestimmten Fällen* erhalten Sie eine schnelle und bequeme Behandlung per
    Video – egal wo Sie gerade sind, Tag und Nacht.
  </p>
  <!-- <p>
    Schnelle und bequeme Behandlung per Video - egal wo Sie gerade sind, Tag und
    Nacht.
  </p> -->
  <p>
    Erfahrene Ärzte verschiedener Fachrichtungen sind speziell für die
    telemedizinische Tätigkeit ausgebildet und nehmen sich Zeit für eine
    persönliche und kompetente Betreuung.
  </p>
  <p>
    Überweisungen und Rezepte können bei Bedarf direkt vom Medgate Arzt
    ausgestellt werden. So können Sie direkt mit einem Facharzt sprechen.
  </p>
  <ion-button
    v-if="from !== 'contact'"
    size="small"
    fill="clear"
    class="ion-text-wrap ion-no-padding"
    @click="openKostenerstattungModal"
    >Kostenlos für ARAG-Kunden mit Vollversicherung!&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button>
  <div class="ion-margin-top u-color-primary ion-padding-top">
    <ion-icon :src="require('@lib/assets/icons/info.svg')" /> <b>Hinweis:</b>
    <p>
      * Ein digitaler Arztbesuch ist möglich, wenn nach allgemein anerkannten
      fachlichen Standards ein persönlicher ärztlicher Kontakt nicht
      erforderlich ist.
    </p>
    <!-- <div>
      Eine Fernbehandlung kann einen persönlichen Arztbesuch nicht ersetzen, ist
      aber eine gute Ergänzung. Ob eine Behandlung ohne persönlichen Kontakt
      erfolgen kann, legt ein Medgate-Arzt im Vorfeld fest.
    </div> -->
  </div>
</template>

<script>
import { modalController, IonButton, IonIcon } from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@arag/components/KostenerstattungModal";
import Header from "@/components/Header";

export default {
  emits: ["open-chat"],
  components: {
    IonButton,
    IonIcon,
    Header,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
